import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// RouterTab 内置路由
import { RouterTabRoutes } from "vue-router-tab";
const routes = [
    { path: "*", redirect: "/main" },
    {
        path: "/main",
        name: "Main",
        component: () => import(/* webpackChunkName: "main" */ "./views/main.vue"),
        children: [
            ...RouterTabRoutes,
            { path: "/main", redirect: "/main/index" },
            {
                path: "/main/index",
                name: "index",
                component: () => import(/* webpackChunkName: "main" */ "./views/0首页/index.vue"),
                meta: { title: "首页", closable: false },
            },
            //对接方
            {
                path: "/main/duijiefang",
                name: "duijiefang",
                component: () => import(/* webpackChunkName: "main" */ "./views/a对接方/对接方.vue"),
                meta: { title: "对接方", closable: true },
            },
            //代理商
            {
                path: "/main/dls/list",
                name: "dlslist",
                component: () => import(/* webpackChunkName: "main" */ "./views/1代理商团队/1代理商列表.vue"),
                meta: { title: "代理商列表", closable: true },
            },
            {
                path: "/main/dls/payset",
                name: "dlsPaySet",
                component: () => import(/* webpackChunkName: "main" */ "./views/1代理商团队/2提现账户设置.vue"),
                meta: { title: "提现账户设置", closable: true },
            },
            //商户
            {
                path: "/main/sh/list",
                name: "shList",
                component: () => import(/* webpackChunkName: "main" */ "./views/2商户管理/1商户列表信息.vue"),
                meta: { title: "商户列表信息", closable: true },
            },
            {
                path: "/main/sh/mdList",
                name: "shMdList",
                component: () => import(/* webpackChunkName: "main" */ "./views/2商户管理/2商户门店列表.vue"),
                meta: { title: "商户门店列表", closable: true },
            },
            {
                path: "/main/sh/zfTdList",
                name: "zfTdList",
                component: () => import(/* webpackChunkName: "main" */ "./views/2商户管理/3支付通道列表.vue"),
                meta: { title: "支付通道列表", closable: true },
            },
            {
                path: "/main/sh/ranking",
                name: "shRanking",
                component: () => import(/* webpackChunkName: "main" */ "./views/2商户管理/4商户交易量排行.vue"),
                meta: { title: "商户交易量排行", closable: true },
            },
            {
                path: "/main/sh/shoufei",
                name: "shoufei",
                component: () => import(/* webpackChunkName: "main" */ "./views/2商户管理/9门店收费.vue"),
                meta: { title: "门店收费明细", closable: true },
            },
            {
                path: "/main/sh/shoufeishezhi",
                name: "shoufeishezhi",
                component: () => import(/* webpackChunkName: "main" */ "./views/2商户管理/10门店收费设置.vue"),
                meta: { title: "门店收费设置", closable: true },
            },
            //壹新支付
            {
                path: "/main/yxjy/jymx",
                name: "yxjymx",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/1交易明细.vue"),
                meta: { title: "交易明细", closable: true },
            },
            {
                path: "/main/yxjy/rjl",
                name: "yxjyjl",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/2自然日记录.vue"),
                meta: { title: "自然日记录", closable: true },
            },
            {
                path: "/main/yxjy/skrjl",
                name: "yxjySkrjl",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/8商户日记录.vue"),
                meta: { title: "商户日记录", closable: true },
            },
            {
                path: "/main/yxjy/skhz",
                name: "yxjyhz",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/3收款汇总.vue"),
                meta: { title: "收款汇总", closable: true },
            },
            {
                path: "/main/yxjy/dz",
                name: "yxjydz",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/4银行到账记录.vue"),
                meta: { title: "银行到账记录", closable: true },
            },
            {
                path: "/main/yxjy/duiz",
                name: "yxjyduiz",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/5对账.vue"),
                meta: { title: "对账", closable: true },
            },
            {
                path: "/main/yxjy/dzzrtj",
                name: "yxjydzzrtj",
                component: () => import(/* webpackChunkName: "main" */ "./views/3壹新支付交易/7到账自然日统计.vue"),
                meta: { title: "到账自然日统计", closable: true },
            },
            {
                path: "/main/sr/dlsDetail",
                name: "dlsDetail",
                component: () => import(/* webpackChunkName: "main" */ "./views/5收入/1代理商收入详情.vue"),
                meta: { title: "代理商收入详情", closable: true },
            },
            {
                path: "/main/sr/detailhz",
                name: "srDetailhz",
                component: () => import(/* webpackChunkName: "main" */ "./views/5收入/收入汇总.vue"),
                meta: { title: "收入汇总", closable: true },
            },
            {
                path: "/main/sr/detail",
                name: "srDetail",
                component: () => import(/* webpackChunkName: "main" */ "./views/5收入/2收入明细.vue"),
                meta: { title: "收入明细", closable: true },
            },
            {
                path: "/main/fp/listhz",
                name: "fpListhz",
                component: () => import(/* webpackChunkName: "main" */ "./views/6发票/发票汇总.vue"),
                meta: { title: "发票汇总", closable: true },
            },
            {
                path: "/main/fp/list",
                name: "fpList",
                component: () => import(/* webpackChunkName: "main" */ "./views/6发票/1发票明细.vue"),
                meta: { title: "发票明细", closable: true },
            },
            {
                path: "/main/qb/txDetail",
                name: "qbtxDetail",
                component: () => import(/* webpackChunkName: "main" */ "./views/7钱包/1提现记录.vue"),
                meta: { title: "提现记录", closable: true },
            },
            {
                path: "/main/qb/detailhz",
                name: "qbDetailhz",
                component: () => import(/* webpackChunkName: "main" */ "./views/7钱包/钱包汇总.vue"),
                meta: { title: "钱包汇总", closable: true },
            },
            {
                path: "/main/qb/detail",
                name: "qbDetail",
                component: () => import(/* webpackChunkName: "main" */ "./views/7钱包/2钱包明细.vue"),
                meta: { title: "钱包明细", closable: true },
            },
            {
                path: "/main/qb/set",
                name: "qbSet",
                component: () => import(/* webpackChunkName: "main" */ "./views/7钱包/3提现账户设置.vue"),
                meta: { title: "提现账户设置", closable: true },
            },

            //发分润
            {
                path: "/main/dr/zb",
                name: "drzb",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/1发分润总表.vue"),
                meta: { title: "发分润总表", closable: true },
            },
            {
                path: "/main/dr/detail",
                name: "drdetail",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/2发分润明细.vue"),
                meta: { title: "发分润明细", closable: true },
            },
            {
                path: "/main/dr/shxj",
                name: "drshxj",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/3审核下级发票.vue"),
                meta: { title: "审核下级发票", closable: true },
            },
            {
                path: "/main/dr/shxjqb",
                name: "drshxjqb",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/4下级钱包明细.vue"),
                meta: { title: "下级钱包明细", closable: true },
            },
            {
                path: "/main/dr/xjtx",
                name: "drxjtx",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/5下级提现到银行卡.vue"),
                meta: { title: "下级提现到银行卡", closable: true },
            },
            {
                path: "/main/dr/setkp",
                name: "drsetkp",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/6开票信息设置.vue"),
                meta: { title: "开票信息设置", closable: true },
            },
            {
                path: "/main/dr/dlsrye",
                name: "drdlsrye",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/90代理余额.vue"),
                meta: { title: "代理余额", closable: true },
            },
            {
                path: "/main/dr/ffrtj",
                name: "ffrtj",
                component: () => import(/* webpackChunkName: "main" */ "./views/4发分润/7发分润统计.vue"),
                meta: { title: "发分润统计", closable: true },
            },
            //移动端装修
            {
                path: "/main/app/zx",
                name: "appzx",
                component: () => import(/* webpackChunkName: "main" */ "./views/8移动端装修/1移动端装修.vue"),
                meta: { title: "移动端装修", closable: true },
            },
            //订货小程序装修
            {
                path: "/main/app/kmfzx",
                name: "kmfzx",
                component: () => import(/* webpackChunkName: "main" */ "./views/9订货小程序装修/1订货小程序装修.vue"),
                meta: { title: "订货小程序装修", closable: true },
            },
            //设置
            {
                path: "/main/set/bmd",
                name: "setBmd",
                component: () => import(/* webpackChunkName: "main" */ "./views/9设置/白名单.vue"),
                meta: { title: "白名单", closable: true },
            },
            {
                path: "/main/set/otp",
                name: "setOtp",
                component: () => import(/* webpackChunkName: "main" */ "./views/9设置/OTP用户.vue"),
                meta: { title: "OTP用户", closable: true },
            },
            {
                path: "/main/set/hmd",
                name: "setHmd",
                component: () => import(/* webpackChunkName: "main" */ "./views/9设置/黑名单.vue"),
                meta: { title: "入网黑名单", closable: true },
            },
            {
                path: "/main/set/cs",
                name: "setCs",
                component: () => import(/* webpackChunkName: "main" */ "./views/9设置/参数设置.vue"),
                meta: { title: "参数设置", closable: true },
            },
        ],
    },
    { path: "/login", name: "login", component: () => import(/* webpackChunkName: "login" */ "./views/login.vue") },
    { path: "/psw", name: "psw", component: () => import(/* webpackChunkName: "login" */ "./views/psw.vue") },
    { path: "/reg", name: "reg", component: () => import(/* webpackChunkName: "login" */ "./views/reg.vue") },
];

const router = new VueRouter({
    routes,
});

export default router;
